import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Leandingpage from './leandingpage/leandingpage';
import Dashboard from './dashboard/dashboard';
import LoginPage from './login/login';
import Demo from './demo';
import CreateRFQ from './RFQpage/createrfq';
import CreatePO from './POpage/createpo';
import ListPO from './POpage/listpo';
import ListRFQ from './RFQpage/listrfq';
import SupplierDirectory from './RFQpage/supplierDirectory';
import SupplierRFQ from './RFQpage/supplierrfq';
import PoByCustomer from './POpage/customer';
import PoReports from './POpage/reports';
import ForgotPassword from './login/forgetpassword';
import Changepassword from './login/changepassword';
import testingpdf from '../src/testing.pdf';
import ClientAdd from './RFQpage/clientadd';
import ClonePO from './POpage/clonepo';
import CloneRFQ from './RFQpage/clonerfq';
import SupplierList from './POpage/supplierlist';
import ClientList from './POpage/clientlist';
import AlertMessage from './RFQpage/alertmessage';
import AlertMessageall from './RFQpage/alertmessageall';
import AlertMessageallpo from './RFQpage/alertmessageallpo';
import VerifyOtp from './login/VerifyOtp';
import UserProfile from './RFQpage/UserProfile';
import About from './footer/About';
import Contact from './footer/Contact';
import Faqs from './footer/Faqs';

const Routs = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Leandingpage />} />
        <Route path="/clientadd" element={<ClientAdd />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/verify-otp" element={<VerifyOtp />} />
        <Route path="/userprofile" element={<UserProfile />} />
        <Route path="/about" element={<About />} />
    <Route path="/contact" element={<Contact />} />
    <Route path="/faqs" element={<Faqs />} />

        <Route path="/forgetpassword" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<Changepassword />} />
        <Route path="/createrfq" element={<CreateRFQ />} />
        <Route path="/createpo" element={<CreatePO />} />
        <Route path="/clonepo/:id" element={<ClonePO/>} />
        <Route path="/clonerfq/:id" element={<CloneRFQ/>} />
        <Route path="/listpo" element={<ListPO />} />
        <Route path="/listrfq" element={<ListRFQ />} />
        <Route path="/supplier" element={<SupplierDirectory />} />
        <Route path="/supplierpo" element={<SupplierList />} />
        <Route path="/clientlist" element={<ClientList />} />
        <Route path="/supplierrfq" element={<SupplierRFQ/>} />
        <Route path="/customer" element={<PoByCustomer/>} />
        <Route path="/alert" element={<AlertMessage/>} />
        <Route path="/alertall" element={<AlertMessageall/>} />
        <Route path="/alertallpo" element={<AlertMessageallpo/>} />
        <Route path="/reports" element={<PoReports/>} />
        <Route path="/demo" element={<Demo  url={testingpdf}/>} />
        
      </Routes>
    </BrowserRouter>
  );
};

export default Routs;
